const Environment = {
    production: "true" === "true",
    api: "https://oficinavirtual-back.aguasbonaerenses.com.ar/",
    statics: "__REACT_APP_STATICS__",
    recaptchaSiteKey: "6LcvdNAsAAAAACrVp9t1SSekVoYeoLwJyI9hOtDe"
};

if (typeof window !== 'undefined') {
    window._env_ = window._env_ || {};
    window._env_.REACT_APP_GA_MEASUREMENT_ID = "G-EB5NYKY4X2";
}

export default Environment;
